import { AutocompleteDecoClassName } from '../Autocomplete';
import { DecoClassName } from './const';
export function findDecoElem(targetElem) {
    var _a;
    const target = targetElem !== null && targetElem !== void 0 ? targetElem : document;
    return ((_a = target.getElementsByClassName(DecoClassName).item(0)) !== null && _a !== void 0 ? _a : target.getElementsByClassName(AutocompleteDecoClassName).item(0));
}
